import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import apiRoutes from '../../../../app/api/routes';

const IDENTIFICATION_CODE_RESOURCE = 'editIdentificationCode';

const EditIdentificationCodeService = ComposedComponent =>
  reduxFetch([
    {
      resource: IDENTIFICATION_CODE_RESOURCE,
      method: 'put',
      request: (id, body, callback, t) => ({
        url: apiRoutes.identificationCodes(id),
        body,
        meta: {
          callback,
          updateOtherList: {
            resource: 'identificationcode',
            id,
            idProp: 'id',
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'updateIdentificationCodeFailed'),
            onSuccessMessage: t('updateIdentificationCodeSuccess')
          },
        },
      }),
    },
  ])(ComposedComponent);

export default EditIdentificationCodeService;
